<template>
  <b-form-select v-model="selectedBrand" @change="onChange">
    <b-form-select-option :value="null">
      {{ $gettext('No brand') }}
    </b-form-select-option>
    <b-form-select-option v-for="brand in availableBrands" :key="brand.id" :value="brand.id">
      {{ brand.name }}
    </b-form-select-option>
  </b-form-select>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
  name: 'BrandSelector',
  components: {},
  props: {
    preselect: {
      type: Object,
      default: null
    },
  },
  data () {
    return {
      selectedBrand: null // default brand
    }
  },
  computed: {
    ...mapGetters({
      currentCompany: "main/getCurrentCompany",
      availableBrands: "brands/getAvailableBrands",
      brandById: "brands/getBrandById",
    })
  },
  created () {
    if (!this.availableBrands || this.availableBrands.length < 1) {
      this.loadCompanyBrands()
    }
    if (this.preselect) {
      this.selectedBrand = this.preselect.id
    }
  },
  methods: {
    ...mapActions ({
      loadCompanyBrands: "brands/loadCompanyBrands"
    }),
    onChange () {
      this.$emit('change', this.selectedBrand)
    }
  }
}
</script>
<style lang="scss">

</style>
